import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../../core/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {
  NzAutocompleteModule,
  NzButtonModule,
  NzIconModule,
  NzInputModule,
  NzPopconfirmModule,
  NzSpinModule,
  NzTabsModule
} from 'ng-zorro-antd';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {EnterpriseNotificationComponent} from './enterprise-notification.component';
import {EnterpriseNotificationEnterpriseComponent} from './enterprise-notification-enterprise/enterprise-notification-enterprise.component';
import {MatButtonToggleModule, MatPaginator} from '@angular/material';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDialogModule} from '@angular/material/dialog';


@NgModule({
  declarations: [
    EnterpriseNotificationComponent,
    EnterpriseNotificationEnterpriseComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    NzTabsModule,
    NzSelectModule,
    NzIconModule,
    MatButtonToggleModule,
    NzInputModule,
    NzAutocompleteModule,
    NzSpinModule,
    NzPopconfirmModule,
    NzButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
  ],
  exports: [],
  entryComponents:
    []
})
export class EnterpriseNotificationModule {
}
